<template v-if="isValid !== false">
	<div class="w5-view-field" :style="styleParent">

		<div v-if="isValid === 1" class="w5-view-field-wrapper" :style="styleWrapper">
			<!-- заголовок -->
			<div v-if="viewType !== 'image' && !isBoolField" class="w5-view-field-title">{{ Obj.title | ftc }}</div>

			<!-- текстовое поле -->
			<div v-if="viewType === 'text'" class="w5-view-field-value">
				{{ Obj.value | ftc }}<span v-if="Obj.for"> {{ Obj.for | ftc }}</span>
			</div>

			<!-- значение из списка -->
			<div v-else-if="viewType === 'list'" class="w5-view-field-value" :class="field === 'data[services]' || field.indexOf('params[') > -1 ? false : 'w5-status-color-' + Obj.value">
				<template v-if="crud === 'ticketrule' && field === 'rule_set_label'">
					<div class="w5-list-ticket-label"
						:class="'ticket-label-color-' + (Obj.value ? String(Obj.value).toLowerCase() : '')"
						:style="(Obj.value ? 'background-color: ' + String(Obj.value).toLowerCase() : '')" />
				</template>
				<template v-else>
					<template v-if="Obj.multiselect === true && Array.isArray(Obj.value) && Obj.value.length">
						<span v-for="(idx, i) in Obj.value" :key="'span-' + i"><span v-if="i > 0">,</span> {{ valueFromMultiselect(Obj.list, idx) | ftc }}</span>
					</template>
					<template v-else>
						<span v-if="field === 'server_view_type'" :class="'color-type-' + String(Obj.value)" style="font-size: 13px">&#9679;</span>
						{{ Obj.list[Obj.value] | ftc | lower((!/_status$/i.test(field) && !/_register$/i.test(field) && field !== 'server_view_type') || (Obj.value === 'rkn' || Obj.value === 'infra')) }}<span v-if="Obj.for"> {{ Obj.for | ftc }}</span>
						<span v-if="/_status$/i.test(field) && Obj.text"> &nbsp;({{ Obj.text | ftc | lower }})</span>
					</template>
				</template>
			</div>

			<!-- money -->
			<div v-else-if="viewType === 'money'" class="w5-view-field-value">
				<Money :value="Obj.value | money2" /> <span v-html="localeFtc('main/ruble')"> </span> <span v-if="Obj.for && Obj.for !== 'main/ruble'">/ <span v-html="localeFtc(Obj.for)"> </span></span>
			</div>

			<!-- Страна -->
			<div v-else-if="viewType === 'country'" class="w5-view-field-value">
				<span
					class="flag-icon"
					:class="'flag-icon-' + Obj.value"
					:title="Obj['list'][Obj.value]"
					style="top: -1px">
				</span>
				{{ Obj['list'][Obj.value] | ftc }}
			</div>

			<!-- большой текст -->
			<div v-else-if="viewType === 'textarea'" class="w5-view-field-value">
				<pre v-if="Obj.translate === false" class="w5-view-field-pre" v-withSafeTags="linkifyText(Obj.value)"></pre>
				<pre v-else class="w5-view-field-pre" v-withSafeTags="localeFtc(linkifyText(Obj.value))"></pre>
			</div>

			<!-- Email -->
			<div v-else-if="viewType === 'email'" class="w5-view-field-value">
				<a :href="'mailto:' + Obj.value" class="linkified">{{ Obj.value }}</a>
			</div>

			<!-- Skype -->
			<div v-else-if="viewType === 'skype'" class="w5-view-field-value">
				<a :href="'skype:' + Obj.value + '?call'" class="linkified">{{ Obj.value }}</a>
			</div>

			<!-- дата и время -->
			<div v-else-if="viewType === 'datetime'" class="w5-view-field-value">
				{{ formater_StrDateFormat(Obj.value, 'd.m.y H:M:S') }}
			</div>

			<!-- дата -->
			<div v-else-if="viewType === 'date'" class="w5-view-field-value">
				{{ formater_StrDateFormat(Obj.value, 'd.m.Y') }}
			</div>

			<!-- логическое -->
			<div v-else-if="viewType === 'bool'" class="w5-view-field-value">
				<template v-if="isBoolField">
						<input type="checkbox" class="w5-checkbox-field" />
						<label class="view-field">{{ Obj.title | ftc }}</label>
				</template>
				<template v-else>
					{{ normalizeBooleanValue(Obj.value) ? 'main/yes' : 'main/no' | ftc }}
				</template>
			</div>

			<!-- картинка -->
			<img v-else-if="viewType === 'image'" :src="srcImage" class="w5-view-field-image" :class="{ 'real-height': crud === 'paymentsaved' }" />

			<!-- массив значений -->
			<div v-else-if="viewType === 'array'" class="w5-view-field-value" style="white-space: normal">
				<template v-for="(o, idx) in Obj['value']">
					<linkComponent :key="idx" :url="arrayUrl(idx)" :text="arrayText(idx)" /><span v-if="idx < Obj['value'].length - 1" :key="'sepor-' + idx">, </span>
				</template>
			</div>

			<!-- Файл -->
			<div v-else-if="viewType === 'note_file'" class="w5-view-field-value">
				<!-- изображение -->
				<previewImageComponent :url="APIServerUrl + Obj['value']" :title="Obj['title'] | ftc" :text="Obj['text'] | ftc" :size="Obj['size']" />
				<!-- ссылка на скачивание -->
				<a :href="APIServerUrl + Obj['value']" class="w5-view-field-download-link"><font-awesome-icon icon="file-download" /></a>
				<!-- размер файла -->
				<span v-if="Obj && Obj['size']">{{ Obj['size'] }}</span>
				<!-- сопровождающий текст -->
				<span v-if="Obj && Obj['text']">{{ Obj['text'] | ftc }}</span>
			</div>

			<!-- внешняя ссылка -->
			<div v-else-if="viewType === 'externalUrl'" class="w5-view-field-value">
				<a :href="makeExternalUrl(Obj.value)" target="_blank" rel="noopener noreferrer">{{ Obj.value | ftc }}</a>
			</div>

			<!-- иное -->
			<div v-else class="w5-view-field-value">
				{{ Obj.value | ftc }}<span v-if="Obj.for"> {{ Obj.for | ftc }}</span>
			</div>
		</div>

		<div v-if="isValid === 2" class="w5-view-field-wrapper" :style="Link && Link.url && String(Link.url).indexOf('/servergroup/') == 0 ? 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap;' : null">
			<div class="w5-view-field-title">{{ Link.title | ftc }}</div>
			<!-- глоб.фильтр -->
			<template v-if="$store.state.user_type === 'admin' && Obj['account_id'] && Obj['account_name']">
				<font-awesome-icon v-if="!Obj['global_filter'] || Obj['global_filter']['value'] != Obj['account_id']['value']"
					class="global-filter-button"
					:title="'account/filter' | ftc"
					@click="setAccountGlobalFilter(Obj['account_id']['value'])"
					icon="filter"
				/>
				<font-awesome-layers v-if="Obj['global_filter'] && Obj['global_filter']['value'] == Obj['account_id']['value']"
					class="global-filter-button global-filter-button-remove"
					:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
					@click="setAccountGlobalFilter()">
					<font-awesome-icon icon="filter" />
					<font-awesome-icon icon="times" />
				</font-awesome-layers>
			</template>
			<!-- тип просмотра сервера -->
			<span v-if="Obj.server_view_type && ('value' in Obj.server_view_type)" :class="'color-type-' + String(Obj.server_view_type.value)" style="font-size: 13px">&#9679;</span>
			<!-- сама ссылка -->
			<linkComponent v-if="Link.access" class="w5-view-field-value"
				:url="Link.url"
				:text="Link.text"
				:flagicon="Link.flag" 
				:imageBefore="Link.image"
				/>
			<div v-else class="w5-view-field-value">{{ Link.text | ftc }}</div>

			<span v-if="Link.online" class="online-status-is-on"> &#9679;</span>
		</div>

		<div v-if="isValid === 3" :style="styleWrapper">
			<!-- Права ролей -->
			<table v-if="viewType === 'permissions'" class="w5-view-field-table">
				<thead>
					<tr>
						<th colspan="2">{{ 'main/permissions' | ftc }}</th>
					</tr>
					<tr>
						<th style="width: 120px">{{ 'main/object' | ftc }}</th>
						<th>{{ 'main/actions' | ftc }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(role, key) in Obj" :key="'role-' + key">
						<td>{{ role.name | ftc }}</td>
						<td>
							<template v-for="(R, k, i) in role.actions">
								{{ R | ftc }}<span v-if="i < Object.keys(role.actions).length - 1" :key="'sepor-for-' + i">, </span>
							</template>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="isValid === 4 && viewType === 'serviceData' && Obj && Obj.value && typeof Obj.value === 'object' && Object.keys(Obj.value).length" :style="styleWrapper"
			class="w5-view-field-wrapper">
			<!-- заголовок -->
			<div class="w5-view-field-title">{{ Obj.title | ftc }}</div>

			<!-- значение -->
			<div v-for="(val, key) in Obj.value" class="w5-view-field-service-data" :key="'srv-data-' + key">
				<!-- если это массив значений -->
				<template v-if="Array.isArray(val)">
					<!-- заголовок -->
					<span class="w5-view-field-value">{{ key | ftc }}</span>
					<br>
					<template v-for="(arr, idx) in val">
						<!-- заголовок -->
						<br v-if="idx > 0" :key="'br-srv-data-' + idx" />						
						<template v-if="typeof arr === 'object'">
							<span class="w5-view-field-value" :key="'val-srv-data-obj-' + idx">&nbsp; &nbsp;{{ idx | ftc }}</span>
							<br :key="'br-srv-data-second-' + idx">
							<template v-for="(prop, nm, ix) in arr">
								<span :key="'s1' + idx + '_' + nm">&nbsp; &nbsp; &nbsp; &nbsp;{{ nm | ftc }}:</span> <span :key="'s2' + idx + '_' + nm">{{ prop | ftc }}</span><br v-if="ix < Object.keys(arr).length - 1" :key="'spbr' + idx + '_' + nm" />
							</template>
						</template>
						<template v-else>
							<span :key="'val-srv-data-str-' + idx">&nbsp; &nbsp;{{ idx | ftc }}: </span>
							<span :key="'s3' + idx">{{ arr }}</span>
						</template>
					</template>
				</template>
				<!-- это какой то объект -->
				<template v-else-if="typeof val === 'object'">
					<!-- заголовок -->
					<span class="w5-view-field-value">{{ key | ftc }}</span>
					<br>
					<span v-for="(prop, nm, idx) in val" :key="'spp1' + nm">
						<template v-if="typeof prop === 'object'">
							<span>&nbsp; &nbsp;{{ nm | ftc }}:<br /></span>
							<span v-for="(prop1, nm1, idx1) in prop" :key="'sppp1' + nm1">
								<template v-if="typeof prop1 === 'object'">
									<span>&nbsp; &nbsp; &nbsp; &nbsp;{{ nm1 | ftc }}:<br /></span>
									<span v-for="(prop2, nm2, idx2) in prop1" :key="'spppp1' + nm2">
										<span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{{ nm2 | ftc }}:</span>
										<span>{{ prop2 | ftc }}</span>
										<br v-if="idx2 <= Object.keys(prop1).length - 1" />
									</span>
								</template>
								<template v-else>
									<span>&nbsp; &nbsp; &nbsp; &nbsp;{{ nm1 | ftc }}:</span>
									<span>{{ prop1 | ftc }}</span>
									<br v-if="idx1 <= Object.keys(prop).length - 1" />
								</template>
							</span>
						</template>
						<template v-else>
							<span>&nbsp; &nbsp;{{ nm | ftc }}:</span>
							<span>{{ prop | ftc }}</span>
							<br v-if="idx <= Object.keys(val).length - 1" />
						</template>
					</span>
				</template>
				<!-- это какое то простое свойство -->
				<template v-else>
					<!-- заголовок -->
					<span class="w5-view-field-value">{{ key | ftc }}</span>
					<br/>
					&nbsp; &nbsp;{{ val }}
				</template>
			</div>
		</div>

		<div v-if="isValid === 5 && Obj && Obj.value" :style="styleWrapper" class="w5-view-field-wrapper user-token">
			<h4>{{ Obj.title | ftc }}</h4>
			<p v-withSafeTags="localeFtc('user/token_description')" class="note"></p>
			<div v-if="viewType === 'userToken'" class="w5-view-field-value">
				{{ Obj.value | ftc }}
			</div>
			<span class="btn btn-submit" :disabled="!isAccess('user/update')" @click.stop="openTokenUpdateModal">{{ 'main/edit' | ftc }}</span>

			<transition name="modal">
				<div v-show="showTokenUpdateModal" @click="hideTokenUpdateModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'main/edit' | ftc }}</span>
								<button type="button" class="close" @click="hideTokenUpdateModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<p>{{ 'user/token_update_confirm' | ftc }}</p>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span v-show="tokenUpdateModalTimer >= 0" class="btn btn-submit btn-submit-danger pull-right" :disabled="tokenUpdateModalTimer && tokenUpdateModalTimer > 0 ? 'disabled' : false" @click="tokenUpdateModalCallback">{{ tokenUpdateModalButtonTitle | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>

		<div v-if="isValid === 6" class="w5-view-field-wrapper" :style="styleWrapper">
			<!-- заголовок -->
			<div class="w5-view-field-title">{{ Obj.title | ftc }}</div>
			<!-- статус -->
			<div v-if="viewType === 'status'" class="w5-view-field-value" :class="Obj.status_color ? 'w5-status-color-' + String(Obj.status_color).toLowerCase() : null">
				{{ Obj.value | ftc }}
			</div>
		</div>

		<div v-if="isValid === 7" class="w5-view-field-wrapper" :style="styleWrapper">
			<!-- заголовок -->
			<div class="w5-view-field-title">{{ arrayViewTitle | ftc }}</div>
			<!-- список объектов -->
			<template v-if="viewType == 'arrayObjects'">
				<div v-for="(element, idx) in Obj" :key="idx">
					<!-- объект = ссылка -->
					<template v-if="element &&
						element['service_id'] && element['service_id']['value'] &&
						element['service_name'] && element['service_name']['value']">
						<linkComponent v-if="isAccess('service/view')" class="w5-view-field-value"
							:url="`/service/view/${element['service_id']['value']}`"
							:text="element['service_name']['value']"
						/>
						<div v-else class="w5-view-field-value">{{ element['service_name']['value'] | ftc }}</div>
					</template>
				</div>
			</template>
		</div>

	</div>

</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/bus.js'
import Helper from '../../helper/helper'
import previewImageComponent from '@/components/elements/previewimg'
import Money from '@/components/elements/money'
import linkifyHtml from 'linkifyjs/html'
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'viewComponent',
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// корректное поле или нет
			isValid: false,
			// текущий объект
			Obj: false,
			// ссылка (если это она)
			Link: {
				name: false,
				title: false,
				url: false,
				text: false,
				flag: null,
				online: false,
				image: null,
				access: false
			},
			// вид компонента
			viewType: false,

			// диалог смены токена пользователя
			showTokenUpdateModal: false,
			tokenUpdateModalTimer: 0,
			tokenUpdateModalTimerHandle: null
		}
	},
	//=========================================================================
	// неизменяемые свойства компонента
	//=========================================================================
	props: [
		// название CRUD, по которому идет запрос на сервер
		'crud',
		// название CRUD объекта на самом деле
		'realCrudName',
		// данные, пришедшие с сервера в чистом виде
		'data',
		// количество полей в текущей строке
		'rowCount',
		// текущая строка
		'y',
		// текущий элемент
		'x',
		// наименование поля
		'field',
		// самый первый элемент в первой строке
		'firstElement',
		// ID объекта
		'objectId'
	],
	//=========================================================================
	// вычисляемые свойства компонента
	//=========================================================================
	computed: {
		// вычисляем стиль главного блока
		styleParent() {
			// пока пусто
			let style = []

			// ширина врапера по умолчанию
			let w = 'width: ' + (100 / (this.rowCount ? this.rowCount : 1)) + '%'

			// если это картинка - ширина будет другой
			if (this.viewType === 'image')
			{
				w = 'width: 110px'
				style.push('top: 1px')
			}
			else
			{
				// это не картинка - а если есть картинка вообще, требуется реорганизация полей (если это не мобила)
				if (this.viewHasImage && this.$store.state.windowWidth > 767)
				{
					// сотрудники
					if (this.crud === 'admin')
					{
						if (this.y === '1') w = 'width: calc(33.33% - 36.67px)'
						if (this.y === '2')
						{
							w = this.rowCount === 1 ? 'width: calc(100% - 110px)' : 'width: calc(50% - 55px)'
							if (this.x === 0)
							{
								style.push('margin-left: 110px')
								style.push('margin-top: -55px')
							}
							else if (this.x >= 1)
							{
								style.push('margin-top: -55px')
							}
						}
					}

					// пользователи
					if (this.crud === 'user')
					{
						if (this.y === '1') w = 'width: calc(50% - 55px)'
						if (this.y === '2')
						{
							style.push('margin-top: -55px')
							if (this.rowCount > 1)
							{
								if (this.x === 0)
								{
									w = 'width: calc(50% - 110px)'
									style.push('margin-left: 110px')
								}
								else
								{
									w = 'width: 50%'
								}
							}
							else
							{
								style.push('margin-left: 110px')
							}
						}
					}

					// шаблоны, способы оплаты и группа тарифов
					if (this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup')
					{
						if (+this.y <= 2) w = 'width: calc(50% - 55px)'
						if (this.y === '2')
						{
							if (this.x === 0)
							{
								style.push('margin-left: 110px')
								style.push('margin-top: -55px')
							}
							else if (this.x >= 1)
							{
								style.push('margin-top: -55px')
							}
						}
					}

					// сохраненные оплаты
					if (this.crud === 'paymentsaved')
					{
						if (this.y === '1') w = 'width: calc(50% - 55px)'
						if (this.y === '2')
						{
							style.push('margin-top: -55px')
							if (this.rowCount > 1)
							{
								if (this.x === 0)
								{
									w = 'width: calc(50% - 110px)'
									style.push('margin-left: 110px')
								}
								else
								{
									w = 'width: 50%'
								}
							}
							else
							{
								style.push('margin-left: 110px')
							}
						}
					}
				}
			}

			style.push(w)

			// возвращаем
			return style.join(';')
		},
		// вычисляем стиль блока-враппера
		styleWrapper() {
			if (this.viewType === 'image')
			{
				// частные случаи
				if (this.crud === 'paymentsaved')
				{
					return 'padding: 0; background-color: transparent; text-align: center; display: flex; align-items: center; justify-content: center; min-height: 102px;'
				}

				// для остальных картинок
				return 'padding: 0; background-color: transparent; text-align: center;'
			}

			return false
		},
		// есть ли вообще во всей View картинка
		viewHasImage() {
			// картинки есть только в этих объектах
			if (this.crud === 'admin' || this.crud === 'user' ||
				this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup' ||
				this.crud === 'paymentsaved')
			{
				// картинки может и не быть - нужно проверить
				let _field = this.firstElement
				if (_field.indexOf('avatar_path') >= 0 || _field.indexOf('image_path') >= 0 || _field.indexOf('saved_image') >= 0)
					return true
			}

			// по умолчанию картинки нет
			return false
		},
		// источник для картинки
		srcImage() {
			return Vue.APIServerUrl + this.Obj['value']
		},
		// если в булевом поле нужен именно чекбокс
		isBoolField() {
			if (this.crud === 'certificate' && this.field === 'service_autoprolong')
				return true

			return false
		},
		// заголовок кнопки диалога изменения токена пользователя
		tokenUpdateModalButtonTitle() {
			if (this.tokenUpdateModalTimer > 0)
				return this.localeFtc('user/token_update_timer').replace('{count}', this.tokenUpdateModalTimer)
			else
				return this.localeFtc('main/edit')
		},
		// заголовок элмента массива объектов
		arrayViewTitle() {
			// берем его из первого элемента
			let _el = this.Obj[0]
			// из первого поля объекта
			if (_el && typeof _el === 'object') {
				for (let prop in _el) {
					if (_el[prop] && typeof _el[prop] === 'object' && _el[prop].title) {
						return _el[prop].title
					}
				}
			}

			return this.field
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		// текущий просматриваемый объект
		this.Obj = Helper.findObj(this.field, this.data, this.crud)
		if (!this.Obj || typeof this.Obj !== 'object') return

		// проверка объекта на наличие полей
		if ('title' in this.Obj || 'value' in this.Obj)
		{
			// сразу метим как валидное значение
			this.isValid = 1
			// запомним тип
			if ('type' in this.Obj)
			{
				// теперь идут стандартные поля
				if (this.Obj['type'] === 'text' || this.Obj['type'] === 'integer') this.viewType = 'text'
				else if (this.Obj['type'] === 'list' && 'list' in this.Obj && this.Obj['list']) this.viewType = 'list'
				else if (this.Obj['type'] === 'list' && !('list' in this.Obj) && 'value' in this.Obj && Array.isArray(this.Obj['value'])) this.viewType = 'array'
				else if (this.Obj['type'] === 'textarea') this.viewType = 'textarea'
				else if (this.Obj['type'] === 'datetime') this.viewType = 'datetime'
				else if (this.Obj['type'] === 'date') this.viewType = 'date'
				else if (this.Obj['type'] === 'boolean') this.viewType = 'bool'
				else if (this.Obj['type'] === 'image') this.viewType = 'image'
				else if (this.Obj['type'] === 'money') this.viewType = 'money'
				else if (this.Obj['type'] === 'email') this.viewType = 'email'
				else if (this.Obj['type'] === 'skype') this.viewType = 'skype'
				else if (this.Obj['type'] === 'file')
				{
					if (this.crud === 'notes' && this.field === 'note_file')
					{
						this.viewType = 'note_file'
					}
					else console.log('1++++++++++++++++++++++++++++ ' + this.field)
				}

				// частный случай
				if (this.crud === 'rackdevice' && this.Obj['type'] === 'text' &&
					(this.field === 'device_ip' || this.field === 'device_host'))
				{
					this.viewType = 'externalUrl'
				}
				// частный случай
				if (this.crud === 'user' && this.Obj['type'] === 'text' && this.field === 'user_access_token')
				{
					this.isValid = 5
					this.viewType = 'userToken'
				}
				// частный случай
				if (this.crud === 'logsIpBlackList' && this.Obj['type'] === 'text' && this.field === 'status')
				{
					this.isValid = 6
					this.viewType = 'status'
					this.Obj.status_color = this.data && this.data.__ip && this.data.__ip.status_color
						? this.data.__ip.status_color
						: false
				}
			}
			// отдельные свойства
			else if (this.field === 'service_data')
			{
				this.isValid = 4
				this.viewType = 'serviceData'
			}
		}
		else if (this.isLink())
		{
			// тоже метим как валидное значение - если это корректная ссылка
			this.isValid = this.makeLink()
		}
		else
		{
			// это не ссылка - это какой то объект с полем
			// может быть это права?
			if (this.field === 'permissions')
			{
				this.isValid = 3
				this.viewType = 'permissions'
			}
			else if (Array.isArray(this.Obj)) {
				this.isValid = 7
				this.viewType = 'arrayObjects'
				console.log('!!!!!!!')
			}
			else
			{
				console.log('2++++++++++++++++++++++++++++ ' + this.field)
			}
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		window.addEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// компонент уничтожается
	//=========================================================================
	beforeDestroy() {
		window.removeEventListener('storage', this.onLocalStorageEvent)

		if (this.tokenUpdateModalTimerHandle)
		{
			clearInterval(this.tokenUpdateModalTimerHandle)
			this.tokenUpdateModalTimerHandle = null
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// текущий объект - ссылка?
		//---------------------------------------------------------------------
		isLink() {
			let _isLink = 0
			let nm = ''
			let p
			let obj = this.Obj

			// если объекта вообще нет
			if (obj === null || obj === undefined || obj === false || obj === '') return false

			// проверим поля, присущие ссылкам
			for (p in obj) if (obj.hasOwnProperty(p))
				if (/_name$/i.test(p) || /_id$/i.test(p) || /_login$/i.test(p))
				{
					nm = p.match(/(.*?)_name$/)
					if (nm === null)
					{
						nm = p.match(/(.*?)_id$/)
						if (nm === null)
						{
							nm = p.match(/(.*?)_login$/)
							if (nm === null)
							{
								// нет полей 'title' и 'value', нет полей присущих ссылкам
								if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле')
								return false
							}
							else nm = nm[1]
						}
						else nm = nm[1]
					}
					else nm = nm[1]
					_isLink++
				}

			// смотрим на результат анализа
			if (_isLink === 2 && this.field !== this.realCrudName)
			{
				this.Link.name = nm
				_isLink = true
			}
			else _isLink = false

			return _isLink
		},
		//---------------------------------------------------------------------
		// формирует данные ссылки - url, text
		//---------------------------------------------------------------------
		makeLink() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получаем ID для ссылки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _id = -1
			if ((this.Link.name + '_id') in this.Obj && 'value' in this.Obj[this.Link.name + '_id'])
				_id = this.Obj[this.Link.name + '_id']['value']

			// формируем корректную ссылку
			let _newName = this.Link.name
			if (this.Link.name === 'program') _newName = 'partnerprogram'
			if (this.Link.name === 'group') _newName = 'servergroup'
			if (this.Link.name === 'service_type') _newName = 'servicetype'
			if (this.Link.name === 'key') _newName = 'sshkey'
			if (this.Link.name === 'device') _newName = 'rackdevice'

			let _nm = _newName

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частные случаи, влияющие на ссылку
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('user_type' in this.Obj)
			{
				_nm = this.Obj['user_type']
			}
			else if ('object_type' in this.Obj && 'value' in this.Obj['object_type'])
			{
				_nm = this.Obj['object_type']['value']
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// может быть и флаг
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('datacenter_country' in this.Obj && 'value' in this.Obj['datacenter_country'])
			{
				this.Link.flag = 'flag-icon-' + this.Obj['datacenter_country']['value']
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// статус пользователя
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('user_online' in this.Obj && this.Obj['user_online'] === true && this.$store.state.user_type === 'admin')
			{
				this.Link.online = true
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// картинка
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ('template_image' in this.Obj && 'value' in this.Obj['template_image'])
			{
				this.Link.image = Vue.APIServerUrl + this.Obj['template_image']['value']
			}

			if ('user_avatar_path' in this.Obj && 'value' in this.Obj['user_avatar_path'])
			{
				this.Link.image = Vue.APIServerUrl + this.Obj['user_avatar_path']['value']
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// запоминаем url
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.Link.url = '/' + _nm + '/view/' + _id

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим текст ссылки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _value = ''
			if (this.Link.name + '_name' in this.Obj && 'value' in this.Obj[this.Link.name + '_name']) _value = this.Obj[this.Link.name + '_name']['value']
			if (this.Link.name + '_login' in this.Obj && 'value' in this.Obj[this.Link.name + '_login']) _value = this.Obj[this.Link.name + '_login']['value']
			this.Link.text = _value

			// если это "способ оплаты"
			if (this.Link.name === 'payment' &&
				'payment_type' in this.Obj &&
				typeof this.Obj['payment_type'] === 'object' &&
				'text' in this.Obj['payment_type'] &&
				this.Obj['payment_type']['text'])
			{
				this.Link.text += ' / ' + String(this.Obj['payment_type']['text'])
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим заголовок поля
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.Link.title = this.Obj[this.Link.name + '_id']['title']

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка прав
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.$store.state.user_type === 'client')
			{
				// к служебным объектам доступ клиентам запрещен
				let _crudValid = ['servicetype', 'account', 'template', 'plan', 'user', 'admin']
				this.Link.access = _crudValid.indexOf(_nm) === -1
			}
			else this.Link.access = true

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// вернем полученный результат - код ссылки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return 2
		},
		//---------------------------------------------------------------------
		// получает ссылку из элемента массива значений
		//---------------------------------------------------------------------
		arrayUrl(idx) {
			let o = this.Obj['value'][idx]
			if (typeof o !== 'object')
			{
				if (this.field === 'user_role' || this.field === 'roles')
					return '/role/view/' + o
			}

			let link = '#'
			let id = false
			let nm = false

			for (let i in o)
			{
				if (/_id$/i.test(i))
				{
					id = o[i]
					nm = i.match(/(.*?)_id$/)
					if (nm !== null) nm = nm[1]
				}
			}

			// поправка
			if (id && nm)
			{
				if (this.field === 'plans') link = '/plan/view/' + id
				else if (this.field === 'groups') link = '/servergroup/view/' + id
				else if (this.field === 'templates') link = '/template/view/' + id
				else link = '/' + this.field + '/view/' + id
			}

			return link
		},
		//---------------------------------------------------------------------
		// получает текст из элемента массива значений
		//---------------------------------------------------------------------
		arrayText(idx) {
			let o = this.Obj['value'][idx]
			if (typeof o !== 'object') return o

			let text = ''
			for (let i in o)
			{
				if (!/_id$/i.test(i))
				{
					text = o[i]
					break
				}
			}

			return text
		},
		//---------------------------------------------------------------------
		// ищем значение в массиве по полю "id"
		//---------------------------------------------------------------------
		valueFromMultiselect(list, val) {
			let _ans = ''
			list.some(item => {
				if (item && item.id && String(item.id) === String(val))
				{
					_ans = item.name ? item.name : val
					return true
				}
			})

			return _ans
		},
		//---------------------------------------------------------------------
		// приводит к булевому значению
		//---------------------------------------------------------------------
		normalizeBooleanValue(value) {
			return Helper.normalizeBooleanValue(value)
		},
		//---------------------------------------------------------------------
		// установка/снятие глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(account) {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// если это установка фильтра
			if (account)
			{
				if (!/\d+/.test(account)) return
				let _accountID = parseInt(account)
				if (isNaN(_accountID) || _accountID < 1) return

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// генерируем событие установки глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'main/set_filter ' + this.Obj['account_name']['value'],
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// тихо рефрешим ВСЮ страницу
							this.$emit('needRefresh')

							// на этом все
							return
						}

						// иная ошибка
						this.$emit('errorFilter', this.formatRequestError(resGet))
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.$emit('errorFilter', this.formatRequestError(resGet))
					}
				)
			}
			// если это очистка глобального фильтра
			else
			{
				// начинаем очистку фильтра - готовим URL согласно API
				let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

				// делаем сам запрос
				this.$http.get(_url).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// обнуляем флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', false)

							// генерируем событие снятия глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр удален
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': this.localeFtc('main/filter') + ' ' + this.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// тихо рефрешим ВСЮ страницу
							this.$emit('needRefresh')

							// на этом все
							return
						}

						// иная ошибка
						this.$emit('errorFilter', this.formatRequestError(resGet))
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.$emit('errorFilter', this.formatRequestError(resGet))
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// форматирование текста с ссылками
		//---------------------------------------------------------------------
		linkifyText(text) {
			// только для заметок
			if (this.field !== 'note_text') return text

			return linkifyHtml(text, {
				defaultProtocol: 'https',
				validate: {
					url: (value) => {
						return /^(http|ftp)s?:\/\//.test(value)
					}
				}
			})
		},
		//---------------------------------------------------------------------
		// формирует ссылку с протоколом
		//---------------------------------------------------------------------
		makeExternalUrl(value) {
			if (!value) return ''

			let str = String(value)

			if (str.indexOf('https://') === 0)
				return str

			if (str.indexOf('http://') === 0)
				return 'https://' + str.substr(7)

			return 'https://' + str
		},
		//---------------------------------------------------------------------
		// диалог обновления токена пользователя
		//---------------------------------------------------------------------
		// открытие
		openTokenUpdateModal() {
			if (!this.isAccess('user/update')) return
			if (!this.objectId) return

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showTokenUpdateModal = true
			this.tokenUpdateModalTimer = 5

			// если задан таймер - запускаем его
			this.tokenUpdateModalTimerHandle = setInterval(() => {
				this.tokenUpdateModalTimer--
				if (this.tokenUpdateModalTimer <= 0)
				{
					clearInterval(this.tokenUpdateModalTimerHandle)
					this.tokenUpdateModalTimerHandle = null
				}
			}, 1000)
		},
		// закрытие
		hideTokenUpdateModal() {
			if (this.tokenUpdateModalTimerHandle)
			{
				clearInterval(this.tokenUpdateModalTimerHandle)
				this.tokenUpdateModalTimerHandle = null
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showTokenUpdateModal = false
			this.hideModalMask()
		},
		// изменение токена
		tokenUpdateModalCallback() {
			if (this.tokenUpdateModalTimer > 0) return
			if (!this.isAccess('user/update')) return
			if (!this.objectId) return

			this.hideTokenUpdateModal()

			this.$http.get(Vue.APIServerUrl + '/user/update/' + this.objectId + '?additional=setNewToken').then(
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						let _post = { '_csrf': _dt['_csrf'] }

						// второй запрос по тому же URL
						this.$http.post(res.url, Helper.toFormData(_post)).then(
							// success
							resPost => {
								// получаем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								if (_dt && _dt['status'] === 'ok')
								{
									// сообщаем что глобальный фильтр установлен
									EventBus.$emit('w5-notificator-add', {
										'title': ' ',
										'message': 'forget/success',
										'class': 'success',
										'type': 'nourl',
										'id': 'success-message',
										'timeout': 2000
									})

									// тихо рефрешим ВСЮ страницу
									this.$emit('needRefresh')
									// на этом все
									return
								}

								// ошибка сервера
								this.$emit('errorFilter', this.formatRequestError(resPost))
							},
							// fail
							resPost => {
								// ошибка сервера
								this.$emit('errorFilter', this.formatRequestError(resPost))
							}
						)

						return
					}

					this.$emit('errorFilter', this.formatRequestError(res))
				},
				res => {
					this.$emit('errorFilter', this.formatRequestError(res))
				}
			)
		},

		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// рефрешим
				this.$emit('needRefresh')
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдаем за свойством data
	//=========================================================================
	watch: {
		'data': function(value) {
			// обновим текущий просматриваемый объект
			this.Obj = Helper.findObj(this.field, this.data)
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		previewImageComponent,
		Money
	}

	//=========================================================================
}
</script>

<style>
.w5-view-field-wrapper {
	padding: 4px 6px;
	border-radius: 4px;
	background-color: #fff;
	border: 1px solid #eee;
}

.w5-view-field-title {	
	font-weight: 400;
	font-size: 12px;
	color: #66afe9;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.w5-view-field-value {
	font-weight: 500;
	min-height: 20px;
	font-size: 14px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	user-select: auto !important;
}

@media (max-width: 767px) {
	.w5-view-field-value {
		white-space: normal;
	}
}

.w5-view-field-pre {
	white-space: pre-wrap;
	margin: 0;
	margin-top: 4px;
	border: 1px solid #eee;
	max-height: 400px;
	overflow: auto;
	background-color: white;
}

.w5-view-field-image {
	width: 98px;
	height: 98px;
}

.w5-view-field-image.real-height {
	height: auto;
    max-height: 98px;
}

.w5-view-field-table {
	width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.w5-view-field-table.auto-layout {
	table-layout: auto;
}
.w5-view-field-table th {
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    background-color: #f6f6f6;
}

.w5-view-field-table.small-font th {
	font-size: 10px;
	font-weight: 400;
}

.w5-view-field-table th, .w5-view-field-table td {
    padding: 3px;
    border: 1px solid #ddd;
}

.w5-view-field-download-link {
	font-size: 20px;
	text-decoration: none;
}

.w5-view-field-service-data {
	margin: 4px 0;
	font-size: 85%;
	padding: 4px;
	border: 1px solid #eee;
	max-height: 400px;
	overflow: auto;
	background-color: white;
}

.w5-checkbox-field + label.view-field {
	height: 37px;
	font-size: 14px;
	font-weight: 500;
}

.w5-checkbox-field:not(checked) + label.view-field:before {
	top: 6px;
}

.w5-checkbox-field:not(checked) + label.view-field:after {
	top: 8px;
}

/* user token */
.w5-view-field-wrapper.user-token {
	padding: 15px;
}
.w5-view-field-wrapper.user-token h4 {
	margin: 0;
	color: #333;
	font-size:18px;
	font-weight:400;
}
.w5-view-field-wrapper.user-token p.note {
	margin: 0;
	padding: 10px 0;
	font-size: 15px;
}
.w5-view-field-wrapper.user-token .w5-view-field-value {
	margin: 0 0 20px 0;
	font-size: 15px;
}
.w5-view-field-wrapper.user-token .btn {
	font-weight: 300;
}
.w5-view-field-wrapper.user-token .btn-submit-danger {
	font-weight: 500;
}

@media (max-width: 767px) {
	.w5-view-field-wrapper.user-token h4,
	.w5-view-field-wrapper.user-token p.note,
	.w5-view-field-wrapper.user-token .w5-view-field-value {
		font-size: 85%;
	}
}
</style>



// WEBPACK FOOTER //
// view.vue?e160c2b8